<template>
  <div
    :class="{
      'border-l border-gray-600': !meta.isFirstDayOfWeek,
      'bg-gray-400': meta.isFocusedDay,
      'bg-gray-200': meta.isDiffMonth,
    }"
    class="flex-1 flex flex-col"
    @click="$emit('set-date', day)"
  >
    <div class="flex text-xs bg-smoke-100 px-1">
      <span v-if="meta.isFirstDayOfWeek" class="text-gray-600">{{ week }} </span
      ><span class="ml-auto">{{ day.date() }}</span>
    </div>
    <div class="date-wrapper flex-1 relative">
      <div class="absolute inset-0 p-1 text-xs overflow-auto cursor-default space-y-1">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Date',
  props: {
    week: {
      type: Number,
      required: true,
    },
    day: {
      type: Object,
      required: true,
    },
    meta: {
      type: Object,
      required: true,
    },
  },
};
</script>
